<template>
  <div class="bg">
    <div class="bc">
      <div class="top_space"/>
      <img class="title_img" loading="lazy" alt>
      <div class="img_space"/>
      <img class="subtitle" loading="lazy" alt/>
      <div class="subtitle_space"/>
      <div class="divider"/>
      <div class="divider_space"/>
      <div class="row no-gutters info_area">
        <div class="row no-gutters info_group">
          <img class="icon" src="/img/image/join/phone.png" loading="lazy" alt="行動電話"/>
          <div class="icon_space"/>
          <div>
            <div class="icon_label">行動電話</div>
            <div class="phone_style">{{ phone }}</div>
          </div>
        </div>

        <div class="row no-gutters info_group">
          <img class="icon" src="/img/image/join/line.png" loading="lazy" alt="Line"/>
          <div class="icon_space"/>
          <div>
            <div class="icon_label">LINE ID</div>
            <div class="line_style">{{ lineId }}</div>
          </div>
        </div>
      </div>
      <div class="down_space"/>
    </div>
  </div>
</template>

<script>
import {isEmpty} from "../../util/helpers";

export default {
  name: "Join_4",
  computed: {
    settingData() {
      return this.$store.getters.getSettingData;
    },
    lineId() {
      let val = this.settingData.data.line_id;
      return isEmpty(val) ? '' : val;
    },
    lineUrl() {
      let val = this.settingData.data.url_line;
      return isEmpty(val) ? '' : val;
    },
    phone() {
      let val = this.settingData.data.phone;
      return isEmpty(val) ? '' : val;
    },
  },
}
</script>

<style lang="scss" scoped>
.bg {
  background-image: url('/img/image/background/bg_s3.png');
  background-size: cover; /* 确保背景图像覆盖整个元素 */
  background-position: center; /* 将图像居中 */
  background-repeat: no-repeat; /* 防止图像重复 */
}

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
  text-align: center;
}

.top_space {
  height: 42px;
}

.title_img {
  width: 1120px;
  height: auto;
  content: url('/img/image/join/join_success.png');
}

@media (max-width: 1200px) {
  .title_img {
    width: 93vw;
  }
}

@media (max-width: 768px) {
  .title_img {
    width: 90vw;
    content: url('/img/image/join/join_success_min.png');
  }
}

@media (max-width: 375px) {
  .title_img {
    width: 300px;
  }
}


.img_space {
  height: 120px;
}

@media (max-width: 768px) {
  .img_space {
    height: 80px;
  }
}

@media (max-width: 425px) {
  .img_space {
    font-size: 20px;
  }
}


.subtitle {
  width: 200px;
  height: auto;
  content: url('/img/image/join/join_success_icon.png');
}

@media (max-width: 768px) {
  .subtitle {
    width: 100px;
  }
}


@media (max-width: 360px) {
  .subtitle {
    width: 68px;
  }
}


.subtitle_space {
  height: 60px;
}


@media (max-width: 425px) {
  .subtitle_space {
    font-size: 20px;
  }
}


.divider {
  content: url('/img/image/join/story_line.png');
  width: 734px;
  height: 2px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .divider {
    width: 95vw;
  }
}


.divider_space {
  height: 50px;
}


.info_area {
  width: 720px;
  justify-content: space-between;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .info_area {
    width: 90vw;
  }
}

@media (max-width: 640px) {
  .info_area {
    width: 75vw;
  }
}

@media (max-width: 576px) {
  .info_area {
    width: 80vw;
  }
}


.info_group {

}

@media (max-width: 768px) {
  .info_group {
    align-items: center;
  }
}

@media (max-width: 640px) {
  .info_group {
    flex-direction: column;
  }
}


.icon {
  width: 120px;
  height: 120px;
}

@media (max-width: 768px) {
  .icon {
    width: 80px;
    height: 80px;
  }
}

@media (max-width: 576px) {
  .icon {
    width: 60px;
    height: 60px;
  }
}


.icon_space {
  width: 24px;
}

@media (max-width: 640px) {
  .icon_space {
    width: 0;
    height: 16px;
  }
}

@media (max-width: 576px) {
  .icon_space {
    height: 8px;
  }
}


.icon_label {
  font-family: Noto Sans TC;
  font-size: 32px;
  font-weight: 500;
  text-align: left;
  color: white;
  margin-top: 14px;
}

@media (max-width: 768px) {
  .icon_label {
    margin-top: 0;
  }
}

@media (max-width: 640px) {
  .icon_label {
    height: 0;
    visibility: hidden;
  }
}

.phone_style {
  font-family: Noto Sans TC;
  font-size: 32px;
  font-weight: 700;
  line-height: 46.34px;
  text-align: center;
  color: #D56835;
}


.line_style {
  font-family: Noto Sans TC;
  font-size: 32px;
  font-weight: 700;
  line-height: 46.34px;
  text-align: center;
  color: #4CC764;
}

@media (max-width: 576px) {
  .phone_style, .line_style {
    font-size: 28px;
  }
}

@media (max-width: 425px) {
  .phone_style, .line_style {
    font-size: 20px;
  }
}

@media (max-width: 360px) {
  .phone_style, .line_style {
    font-size: 16px;
  }
}


.down_space {
  height: 45px;
}

</style>
